import styled, { css } from "styled-components"

export default {
    "TableDiv": styled.div`
        display: flex;
        flex-direction: column;
    `,
    "TableRow": styled.div`
        height: 38px;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 20px;
        cursor: pointer;

        ${({ $title }) => $title && css`
            background-color: ${({ theme }) => theme.color.major};
            cursor: default;
        `}

        ${({ $odd }) => $odd && css`
            background-color: ${({ theme }) => theme.color.grey1};
        `}

        ${({ $break }) => $break && css`
            background-color: ${({ theme }) => theme.color.grey3};
        `}

        ${({ $exapnd }) => $exapnd && css`
            height: fit-content;
        `}
    `,
    "Data": styled.p`
        display: flex;
        gap: 4px;
        height: fit-content;

        ${({ theme }) => theme.font.extra_small};

        ${({ $title }) => $title && css`
            color: ${({ theme }) => theme.color.white};
            ${({ theme }) => theme.font.extra_small_bold};
        `}

        ${({ $size }) => {
            if ($size === "short") return css`
                width: 50px;
            `
            else if ($size === "long") return css`
                width: 150px;
            `
            else if ($size === "longlong") return css`
                width: 200px;
            `
            else if ($size === "longlonglong") return css`
                width: 250px;
            `
            else if ($size === "expand") return css`
                flex-grow: 1;
            `
            else return css`
                width: 100px;
            `
        }}
        
        ${({ $break }) => $break && css`
            color: ${({ theme }) => theme.color.white};
            ${({ theme }) => theme.font.extra_small_bold};
        `}
    `
}